import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Location, UpperCasePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [TranslateModule, UpperCasePipe, ButtonModule],
  templateUrl: './not-found.component.html'
})
export class NotFoundComponent {

  constructor(
    private router: Router,
    private location: Location
  ) {}

  back(): void {
    this.router.navigate(['/']);
    //this.location.back();
  }

}
